import { render, staticRenderFns } from "./HospitalInformation.vue?vue&type=template&id=20c0573a&scoped=true&"
import script from "./HospitalInformation.vue?vue&type=script&lang=js&"
export * from "./HospitalInformation.vue?vue&type=script&lang=js&"
import style0 from "./HospitalInformation.vue?vue&type=style&index=0&id=20c0573a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0573a",
  null
  
)

export default component.exports